exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mv-22 {\n  margin: 22px 0;\n}\n.v-middle {\n  vertical-align: middle !important;\n}\n", ""]);

// exports
